import React, { useEffect, useState } from "react";
import BillboardChart from "react-billboardjs";
import "billboard.js/dist/billboard.css";
import { Box } from "@mui/material";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import axios from "axios";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { ko } from "date-fns/locale";
import moment from "moment";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import add_comma from "../lib/add_comma";

const axis = {
  x: {
    type: "category"
  }
}

const CHART_DATA = {
  x: "x",
  columns: [
    ['x', '무료', '1회권', '4회권', '8회권', '12회권', '20회권', '36회권', '40회권', '60회권'],
    ['data1', 0, 0, 0, 0, 0, 0, 0, 0, 0],
  ],
  type: 'bar',
};

const style = {
  title: {
    fontSize: 18,
    ml: 1,
    mt: 1,
    mb: 1
  }
}

export default function ChartSaleWeekly(props) {

  const { tcidParent } = props;
  const cid = get_cid();
  const token = get_token();
  const [data, setData] = useState(CHART_DATA);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [count, setCount] = useState([0, 0]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [sum, setSum] = useState(0);

  const get_data = async () => {
    let result = await axios.post(configState.api + '/chart/sale_weekly', {
      token: token,
      cid: cid,
      tcid: tcidParent,
      date: date,
    });    
    if (result.data.success === 1) {
      setData({
        x: "x",
        columns: [
          ['x', '무료', '1회권', '4회권', '8회권', '12회권', '20회권', '36회권', '40회권', '60회권', '정기권'],
          result.data.rows,
        ],
        type: "bar",
      });

      setSum(result.data.sum);
    }
  }

  const leftButton = () => {
    setDate(moment(date).add(-1, 'week').format('YYYY-MM-DD'));
  }

  const rightButton = () => {
    setDate(moment(date).add(1, 'week').format('YYYY-MM-DD'));
  }

  useEffect(() => {
    setStart(moment(date).startOf('week').format('YYYY-MM-DD'));
    setEnd(moment(date).endOf('week').format('YYYY-MM-DD'));
    // setStart(moment(date).startOf('week'));

    get_data();
  }, [date, tcidParent]);


  return (
    <Box width={500}>
      <Box display="flex" alignItems="center">
        <Box width={180} marginLeft={3}> 합계:{add_comma(sum)}</Box>
        <Box display="flex" alignItems="center">
          <Box>
            <IconButton color="primary" aria-label="내일" component="label" onClick={leftButton}>
              <ArrowLeftIcon fontSize="large" />
            </IconButton>
          </Box>
          <Box marginLeft={1}>
            {start}-{end}
          </Box>
          <Box marginLeft={1}>
            <IconButton color="primary" aria-label="내일" component="label" onClick={rightButton}>
              <ArrowRightIcon fontSize="large" />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Box>
        <BillboardChart data={data} axis={axis} />
      </Box>
    </Box>
  );
}
